import React from 'react';
import './tableUserLinks.css';
import { Table, Tooltip, Typography } from 'antd';
import { LinkOutlined } from '@ant-design/icons';

const { Paragraph } = Typography

const TableUserLinks = ({ data }) => {
    const columns = [
        {
            title: 'Cédula',
            dataIndex: 'evr_evaluated',
            key: 'evr_evaluated',
        },
        {
            title: 'Nombre Completo',
            dataIndex: 'evr_evaluated_fullname',
            key: 'evr_evaluated_fullname',
        },
        {
            title: 'Cargo',
            dataIndex: 'evr_evaluated_job_title',
            key: 'evr_evaluated_job_title',
        },
        {
            title: 'Relación',
            dataIndex: 'evr_type',
            key: 'evr_type',
        },
        {
            title: 'Status',
            dataIndex: 'evr_finished',
            key: 'evr_finished',
            render: (text, record) => (record.evr_finished ? 'Finalizada' : record.evr_started ? 'Iniciada' : 'Sin iniciar'),
        },
        {
            title: 'Fecha de inicio',
            dataIndex: 'evr_started_at',
            key: 'evr_started_at',
            render: (text, record) => (record.evr_started? new Date(text).toLocaleString() : '-'),
        },
        {
            title: 'Fecha de finalización',
            dataIndex: 'evr_finished_at',
            key: 'evr_finished_at',
            render: (text, record) => (record.evr_finished ? new Date(text).toLocaleString() : '-'),
        },
        // {
        //     title: 'Link',
        //     key: 'link',
        //     render: (_, record) => {
        //         const rootUrl = window.location.origin;
        //         const link = `${rootUrl}/evaluaciones/form/${record.evr_uuid}`;
        //         return (
        //             <Tooltip title="Ir al formulario">
        //                 <a href={link} target="_blank" rel="noopener noreferrer">
        //                     <LinkOutlined style={{ fontSize: 18 }} />
        //                 </a>
        //             </Tooltip>
        //         );
        //     },
        // },
    ];

    return (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        <h2 style={{ textAlign: 'center' }}>Personas a Evaluar</h2>
        <Paragraph style={{ width: '90%' }}>
            A continuación, encontrarás la lista de las personas que deberás evaluar en relación con su ejercicio de liderazgo, junto con la descripción de la relación que tienes con cada una de ellas (por ejemplo: autoevaluación, jefe, colaborador, par, cliente interno). Da click en cada fila para acceder.
        </Paragraph>
        <Table
            style={{ marginTop: 20, width: '90%' }}
            scroll={{ x: 'max-content' }}
            className='table-user-links'
            columns={columns}
            dataSource={data}
            rowKey="evr_uuid"
            pagination={{ pageSize: 10 }}
            onRow={(record) => {
                if (record.evr_finished) {
                    return {}; // No hacer nada si la evaluación está finalizada
                }
                return {
                    onClick: () => {
                        const rootUrl = window.location.origin;
                        const link = `${rootUrl}/evaluaciones/form/${record.evr_uuid}`;
                        window.location.href = link;
                    },
                    style: { cursor: 'pointer' }
                };
            }}
        />
    </div>
    );
};

export default TableUserLinks;
